import React from 'react'
import styled, { css } from 'styled-components'

const width = '13'
const height = '20'
const viewBox = '0 0 13 20'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      fill="#00ADEE"
      d="M0 2.35L7.694 10 0 17.65 2.368 20l10.08-10L2.368 0z"
      key="key-0"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconArrowRight'
})
